import React from 'react';

import {ArchivableItem} from 'archive/ArchiveConstants';
import {getArchiveText} from 'archive/ArchivePurposesUtil';
import getTestProps from 'test/lib/cypress/getTestProps';

import isArchived from '../isArchived';

interface ArchiveRecordLabelProps {
  item: ArchivableItem;
}

/*
 * Renders faded-out details of the archive purpose of the item if archived, or returns null.
 * E.g. `(Expired)`
 */
export default function ArchiveRecordLabel(props: ArchiveRecordLabelProps): JSX.Element | null {
  if (!isArchived(props.item)) {
    return null;
  }
  return (
    <span
      className="faded"
      {...getTestProps({component: 'ArchiveRecordLabel', element: 'archiveRecordLabelText'})}
    >
      {' '}
      ({getArchiveText(props.item)})
    </span>
  );
}
